import { render, staticRenderFns } from "./NoMatches.vue?vue&type=template&id=4430a48d&"
import script from "./NoMatches.vue?vue&type=script&lang=js&"
export * from "./NoMatches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports